import { SOCIAL_PLATFORMS } from '~/constants';
import { ISearchContentResult } from '~/searchApi';
import { formatYoutubeVideoUrl } from '~/utils-ts';

export const getContentExternalUrl = ({
  externalUrl,
  networkId,
  platform,
  shareUrl,
}: ISearchContentResult) => {
  if (platform === SOCIAL_PLATFORMS.youtube && networkId) {
    return formatYoutubeVideoUrl(networkId);
  }

  if (platform === SOCIAL_PLATFORMS.tiktok && externalUrl) {
    return externalUrl;
  }

  return shareUrl;
};
